var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 64H64C28.656 64 0 92.656 0 128v256c0 35.344 28.656 64 64 64h384c35.344 0 64-28.656 64-64V128c0-35.344-28.656-64-64-64M342.656 234.781l135.469-116.094c.938 3 1.875 6 1.875 9.313v256c0 2.219-.844 4.188-1.281 6.281zM448 96c2.125 0 4 .813 6 1.219L256 266.938 58 97.219C60 96.813 61.875 96 64 96zM33.266 390.25C32.828 388.156 32 386.219 32 384V128c0-3.313.953-6.313 1.891-9.313L169.313 234.75zM64 416c-3.234 0-6.172-.938-9.125-1.844l138.75-158.563 51.969 44.531C248.578 302.719 252.297 304 256 304s7.422-1.281 10.406-3.875l51.969-44.531 138.75 158.563c-2.937.906-5.875 1.843-9.125 1.843z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.b80043a0a33c2dd19a1ce55fcac04115.svg";
export { ForwardRef as ReactComponent };